import Sidebar from '../components/sidebar/Sidebar';
import React, {useState} from 'react';
import Footer from '../components/footer/Footer';
import FormsPayrollDetails from "../components/forms/FormsPayrollDetails";
import NavbarForms from "../components/navbar/NavbarForms";


const FormsPayroll = () => {

    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => {
        setIsOpen(!isOpen);
    }

    return (
      <>
        <Sidebar isOpen={isOpen} toggle={toggle} />
        <NavbarForms toggle={toggle} />
          <FormsPayrollDetails/>
        <Footer/>
      </>
  );
};

export default FormsPayroll;
